import {
  getGroupPlans,
  getGroupPlansSuccess,
  getGroupPlansFailure,
  selectGroupPlan,
} from './actions'

import { DispatchFunction } from '../types'

import api from '../../utils/api'
import { PATHS } from '../../config'
import { useAuth } from '../../hooks/useAuth'

const doFetchGroupPlans = () => async (dispatch: DispatchFunction) => {
  dispatch(getGroupPlans())
  try {
    const isAuthenticated = useAuth()
    const result = await api.get(
      isAuthenticated ? PATHS.API_GROUP_PLANS_LOGGED_IN : PATHS.API_GROUP_PLANS
    )
    const plans: any = result?.data
    dispatch(getGroupPlansSuccess(plans))
  } catch (error) {
    console.log(error)
    dispatch(getGroupPlansFailure('Error fetching group plans'))
  }
}

export const selectGroupPlanDispatcher =
  (planId: string) => async (dispatch: DispatchFunction) => {
    dispatch(selectGroupPlan(planId))
  }

export { doFetchGroupPlans }
